import RoutesComponent from './Routes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'react-quill/dist/quill.snow.css';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    const saved = localStorage.getItem('theme');
    console.log(saved);

    if (saved === 'dark') {
      document.body.classList.add('dark_theme');
      localStorage.setItem('theme', 'dark');
    } else if (saved === 'light') {
      localStorage.setItem('theme', 'light');
      document.body.classList.remove('dark_theme');
    } else {
      document.body.classList.add('dark_theme');
      localStorage.setItem('theme', 'dark');
    }
  }, []);

  return (
    <div className="">
      <div className="App">
        <DndProvider backend={HTML5Backend}>
          <RoutesComponent />
        </DndProvider>
        <ToastContainer autoClose={2000} />
      </div>
    </div>
  );
}

export default App;
